<div style="min-width: 350px">
  <div mat-dialog-content>
    <lemon-dialog-header>Vaihda tilikartta</lemon-dialog-header>

    <div style="margin-bottom: 16px">
      Nykyinen tilikartta: <strong>{{ nykyinenProfiiliNimi }}</strong>
    </div>

    <mat-form-field style="width: 100%">
      <mat-label>Uusi tilikartta</mat-label>
      <mat-select [formField]="uusiProfiili" (selectionChange)="profiiliMuuttui($event)">
        @for (profiili of vaihdettavatProfiilit; track profiili) {
          <mat-option [value]="profiili.tunnus">
            {{ profiili.nimi }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (tarkistetaan()) {
      <div style="padding: 8px 0">
        Tarkistetaan…
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }

    @if (virhe()) {
      <div class="error-text" style="padding: 8px 0">
        {{ virhe() }}
      </div>
    }
  </div>

  <div mat-dialog-actions style="padding-left: 0; padding-right: 0; gap: 0.25rem">
    <app-primary-button mat-dialog-close actionId="Tilikartan vaihto: Peruuta">Sulje</app-primary-button>
    <app-secondary-button [disabled]="!tarkistusOk() || tarkistetaan()" (click)="tallenna()" actionId="Tilikartan vaihto: Tallenna">Tallenna</app-secondary-button>
  </div>
</div>
